var Controls = function(gal) {
    var _this = this,
        _toggleThumbs,
        _toggleTags,
        _buildPages,
        _scrollbarTags,
        _scrollbarThumbs,
        _thumbsSel = '#thumbs-wrapper',
        _thumbsScroll = '#thumbs-scroll',
        _thumbsOverviewSel = '#thumbs-overview',
        _tagsSel = '#tags-wrapper',
        _tagsScroll = '#tags-scroll',
        _isFirstOpenTags = true,
        _isFirstOpenThumbs = true,
        _lettersSel = '#letters',
        zoomPercent = dom.getById('zoom-count'),
        zoomIn = dom.getById('btn-zoomin'),
        zoomOut = dom.getById('btn-zoomout');



    var _checkIfLastPage = function() {
        if (gal && gal.gallery && gal.gallery.getCurrentIndex() == gal.gallery.items.length - 1 && !!viewSettings.relatedBrochure && viewSettings.relatedBrochure.brochure_link !== '') {
            window.location.href = viewSettings.relatedBrochure.brochure_link;
            return true;
        }

        return false;
    }

    _toggleThumbs = function() {
        if ($(_tagsSel).is(":visible")) {
            _toggleTags();
        }

        $('#btn-thumbs, #btn-pages').toggleClass('btn-active');
        $(_thumbsSel).slideToggle(150, function() {
            if (_isFirstOpenThumbs) {
                _scrollbarThumbs = new IScroll('#thumbs-viewport', {
                    scrollbars: true,
                    interactiveScrollbars: true,
                    fadeScrollbars: isMobile ? true : false,
                    click: true,
                    mouseWheel: true
                });

                _this.scrollbarThumbs = _scrollbarThumbs;

                bLazy.load(dom.getAll('#thumbs-overview .b-lazy'));

                _isFirstOpenThumbs = false;
            }
        });
    };

    _toggleTags = function() {
        if ($(_thumbsSel).is(":visible")) {
            _toggleThumbs();
        }

        $('#btn-tags').toggleClass('btn-active');
        $(_tagsSel).slideToggle(150, function() {
            if (_isFirstOpenTags) {
                _scrollbarTags = new IScroll('#tags-viewport', {
                    scrollbars: true,
                    interactiveScrollbars: true,
                    fadeScrollbars: isMobile ? true : false,
                    mouseWheel: true
                });

                _this.scrollbarTags = _scrollbarTags;

                _isFirstOpenTags = false;
            }
        });
    };

    _tagsEvents = function() {
        /* Click Tag */

        var $tagLinks = $(_tagsScroll).find('a').on('click', function(e) {
            if (_scrollbarTags.moved) {
                return;
            }

            var link = $(this),
                page = this.getAttribute("data-page"),
                id = this.getAttribute("data-id"),
                layer = gal.isDoubleMode() ? Math.ceil(page / 2) : page;

            _toggleTags();

            layer = parseInt(layer);

            // TODO when ad between slides is present, finish this.
            // if(_adLayerIndex){
            //     if ( gallery.isDoubleMode() && layer >= _adLayerIndex.double) {
            //         layer = layer + 1;
            //     }

            //     if ( !gallery.isDoubleMode() && layer >= _adLayerIndex.single) {
            //         layer = layer + 1;
            //     }
            // }

            gal.gallery.goTo(layer);

            fireEvent(window, 'ui.tag.onclick', { id: id, page: page });
        });
    };


    _buildPages = function() {
        var $thumbsOverview = $(_thumbsOverviewSel);
        $thumbsOverview.html('');

        // var pages = gal.gallery.items;
        var pages = gal.jsonData.originalItems;

        for (var i = 0, pLen = pages.length; i < pLen; i++) {
            var
                page = document.createElement("div");

            page.className = "slider-thumb";

            var j = 1;
            var pageItem = pages[i],
                imgWrapper = document.createElement("div");

            imgWrapper.className = "thumbs b-lazy";

            imgNumber = document.createElement("div");
            imgNumber.className = "thumb-number";

            imgNumber.innerHTML = i + 1;

            if (gal.isDoubleMode()) {
                imgNumber.innerHTML = i + 1; // ? i*2 + j : 1;
            };

            imgWrapper.setAttribute('data-src', pageItem.thumbImage.src);
            imgWrapper.layer = i;

            // if fakepage hide image
            if (pageItem.empty === true) {
                imgWrapper.className = "hidden-important";
            };

            imgWrapper.setAttribute('data-page-inx', i);
            page.onclick = function() {
                if (_scrollbarThumbs.moved) {
                    return;
                }

                var pageInx = parseInt(this.querySelectorAll('.thumbs')[0].getAttribute('data-page-inx'));

                pageInx = gal.isDoubleMode() ? Math.ceil(pageInx / 2) : pageInx;
                gal.gallery.goTo(pageInx);

                _toggleThumbs();
            }

            page.appendChild(imgNumber);

            // if fakepage  dont add thumb
            if (pageItem.empty !== true && typeof pageItem.map === 'undefined') {
                page.appendChild(imgWrapper);
            };

            $thumbsOverview.append(page);
        }
    };

    _closeTags = function() {

    };

    _lettersEvents = function() {
        /* Click Letter Tags */
        var $letterLinks = $(_lettersSel).find('a');

        // for (var i = 0; i < letterLinks.length; i++) {
        $letterLinks.on('click', function(e) {
            if (_scrollbarTags.moved) {
                return;
            }

            var letter = $(this),
                all = dom.getById("tags-scroll").querySelectorAll('.active'),
                id = this.id,
                targetId = id + "-target",
                target = dom.getById(targetId);

            for (var i = 0; i < all.length; i++) {
                dom.removeClass(all[i], 'active');
            }


            if (target) {
                _scrollbarTags.scrollToElement(target);
            }
        });
    };

    _notificationEvents = function(){
        $(document).on('click', '#btn-notification, .js-open-subscribe', function(e) {
            if ($(_tagsSel).is(":visible")) {
                _toggleTags();
            }

            if ($(_thumbsSel).is(":visible")) {
                _toggleThumbs();
            }
        });
    }

    _updateZoomDisplay = function() {
        if(zoomPercent == null || zoomOut == null || zoomIn == null){
            return;
        }

        zoomPercent.innerHTML = (gal.gallery.getZoomLevel() * 100).toFixed(0) + "%",
        currZoom = gal.gallery.getZoomLevel();

        var scale = Number(currZoom).toFixed(2);
        var minZoomScale = Number(gal.gallery.currItem.fitRatio.toFixed(2));
        var maxZoomScale = Number(gal.gallery.options.maxSpreadZoom.toFixed(2));

        if (scale <= minZoomScale) {
            dom.addClass(zoomOut, 'disabled');
            dom.removeClass(zoomIn, 'disabled');
        } else {
            if (scale == maxZoomScale) {
                dom.addClass(zoomIn, 'disabled');
                dom.removeClass(zoomOut, 'disabled');
            } else {
                dom.removeClass(zoomIn, 'disabled');
                dom.removeClass(zoomOut, 'disabled');
            }
        }
    };

    _zoom = function(id) {
        if (gal.isDoubleMode() && gal.gallery.currItem.container.querySelectorAll('.page').length == 0 &&
            gal.gallery.currItem.container.querySelectorAll('.xml-slide').length === 0 ||
            gal.isDoubleMode() == false && gal.isAtEnd() ||
            gal.gallery.currItem.container.querySelectorAll('.block-zoom').length > 0) {
            return;
        }

        var zoomIn = id === 'btn-zoomin' ? true : false,
            zoomStep = 0.2,
            currZoom = gal.gallery.getZoomLevel(),
            newZoom = currZoom + (zoomIn ? zoomStep : -zoomStep);

        if (newZoom > gal.gallery.options.maxSpreadZoom) {
            newZoom = gal.gallery.options.maxSpreadZoom;
        } else if (newZoom < gal.gallery.currItem.fitRatio && gal.gallery.currItem.fitRatio <= 1) {
            newZoom = gal.gallery.currItem.fitRatio;
        }
        newZoom = Math.round(newZoom * 10000) / 10000;

        newZoom = Math.round(newZoom * 10000) / 10000;

        // if(currZoom < gal.gallery.options.maxSpreadZoom){
        gal.gallery.zoomTo(newZoom);
        _updateZoomDisplay();
        gal.handleCounterDisplay();
        gal.handleFrontCover();
        // fireEvent(window, 'slider.zoom');
        // }
    };

    var _initControlButtons = function() {
        var gaLoaded = typeof ga !== 'undefined';

        if(gaLoaded === false){
            console.log('%c Google Analytics scripts are missing. Please check site settings.', 'color: red; font-size: 28px');
        }

        $(document).on('click', '.page-button', function() {
            gaLoaded = typeof ga !== 'undefined';
            
            switch (this.id) {
                case 'next-page':
                    if(!_checkIfLastPage()){
                        if(typeof viewSettings.isRedesign !== 'undefined' && viewSettings.isRedesign === true && gaLoaded){
                            ga('send', 'event', 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), 'next-page-click', window.location.href);
                        }

                        gal.gallery.next();
                    }


                    break;

                case 'prev-page':
                    if(typeof viewSettings.isRedesign !== 'undefined' && viewSettings.isRedesign === true && gaLoaded){
                        ga('send', 'event', 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), 'previous-page-click', window.location.href);
                    }

                    gal.gallery.prev();
                    break;

                case 'first-page':
                    if(typeof viewSettings.isRedesign !== 'undefined' && viewSettings.isRedesign === true && gaLoaded){
                        ga('send', 'event', 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), 'first-page-click', window.location.href);
                    }

                    gal.gallery.goTo(0);
                    break;

                case 'last-page':
                    if(!_checkIfLastPage()){
                        if(typeof viewSettings.isRedesign !== 'undefined' && viewSettings.isRedesign === true && gaLoaded){
                            ga('send', 'event', 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), 'last-page-click', window.location.href);
                        }

                        var lastBrochurePageInx = gal.getOriginalLastPageInx();

                        gal.gallery.goTo(lastBrochurePageInx);
                    }

                    break;

                default:
                    break;
            }
        });
    }

    var _setNextBrochureMobile= function(){
        var $nxtBtn = $('#btn-next-brochure, .js-vr-next-brochure-btn');
        
        if(typeof viewSettings.relatedBrochure !== 'undefined' && !!viewSettings.relatedBrochure && viewSettings.relatedBrochure.brochure_link !== ''){
            $nxtBtn.attr('href', viewSettings.relatedBrochure.brochure_link);
        }else{
            $nxtBtn.hide();
        }
    };

    _init = function() {
        $(document).on('click', '#navigation #btn-tags, #navigation #btn-pages, #view-header .btn-tags, #view-header .btn-thumbs, #btn-zoomin, #btn-zoomout', function(e) {
            var $el = $(this);

            if ($el.hasClass('btn-thumbs') || this.id == "btn-pages") {
                _toggleThumbs();
            }

            if ($el.hasClass('btn-tags') || this.id == 'btn-tags') {
                _toggleTags();
            }

            if ((this.id == 'btn-zoomin' || this.id == 'btn-zoomout') && $(this).hasClass('disabled') === false) {
                _zoom(this.id);
            }
        });


        window.addEventListener('view.slider.zoom', function(event) {
            _updateZoomDisplay();
        });

        _updateZoomDisplay();
        _tagsEvents();
        _lettersEvents();
        _notificationEvents();
        _buildPages();

        _setNextBrochureMobile();
    };

    _this.init = _init;
    _this.scrollbarTags = _scrollbarTags;
    _this.scrollbarThumbs = _scrollbarThumbs;
    _this.initControlButtons = _initControlButtons;
    _this.checkIfLastPage = _checkIfLastPage;
};